import { computed } from 'vue'

import {
  ACCESS_LEVEL_PERMISSION,
} from './const.js'

import rules from './rules.js'

import { useCore } from '@/composables/core/index.js'
import { useEppo } from '@/composables/eppo/index.js'

export const useAccessLevelPermissions = () => {
  const eppo = useEppo()
  const { store } = useCore()

  const loggedUserAccessLevel = computed(() => store.getters['identity/userAccessLevel'])
  const loggedUserPermissionOverrides = computed(() => store.state.business.business.current_staffer?.permission_overrides)

  const hasAccess = (permission) => {
    const rule = rules[permission]
    if (!rule) return false
    return rule({
      accessLevel: loggedUserAccessLevel.value,
      overrides: loggedUserPermissionOverrides.value,
      ff: eppo.ff,
    })
  }

  return {
    ACCESS_LEVEL_PERMISSION,
    hasAccess,
  }
}
